import React from "react";
import Divider from "@mui/material/Divider";

const MiddleInsetHorizontalDivider = (props) => (
  <Divider variant="middle" {...props} />
);

export default MiddleInsetHorizontalDivider;
